// extracted by mini-css-extract-plugin
export var messageSideLeft = "_kp-1";
export var messageSideRight = "_kp-2";
export var subscribeToBackInStockBubbleContainer = "_kp-0";